module.exports = __webpack_public_path__ + "img/ertiga.38dece54.png";